import React, { useContext, useState, useEffect} from "react";
import {PriceCalculationContext} from "../context/PriceCalculationContext";
//Dragablee
import Draggable from "react-draggable";
//wyswig editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {Editor} from "react-draft-wysiwyg";
import {convertToRaw, ContentState} from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import {EditorState} from 'draft-js';
//Toolbar
import {TextSectionsDispatch, TextSectionsListContext} from "../context/TextSectionsListContext";
import {ConfigContext, ConfigDispatch} from "../context/ConfigContext";
import { PriceDispatch} from "../context/PriceContext";
import {ModalDispatch} from "../context/ModalContext";
import button from "bootstrap/js/src/button";
import { checkIfSingIsAllowed, getGridSnapValue, calculateAlignmentPosition} from "../services/helpers";
import {WorkingSizeContext} from "../context/WorkingSizeContext";
import TextSectionLetters from "./TextSectionLetters";
import {LettersContext, LettersDispatch} from "../context/LettersContext";
import {useLanguage} from "../context/LanguageContext";

const TextSection = ({index, value, defaultPosition, defaultFontSize, defaultLetterSpacing, rawValue}) => {
    const {t} = useLanguage();
    const {recalculateAllPrices} = useContext(PriceCalculationContext);
    const priceDispatch = useContext(PriceDispatch);
    const textSectionDispatch = useContext(TextSectionsDispatch);
    const textSection = useContext(TextSectionsListContext);
    const configContext = useContext(ConfigContext);
    const configContextDispatch = useContext(ConfigDispatch);
    const modalDispatch = useContext(ModalDispatch);
    const workingSizeContext = useContext(WorkingSizeContext);
    const lettersMap = useContext(LettersContext);
    const lettersDispatch = useContext(LettersDispatch);
    const sectionLetters = lettersMap[index] || [];
    const [position, setPosition] = useState(defaultPosition);
    const active = textSection[index] ? textSection[index].active : false;

    //Ręcznie ustawiana wartość przylegania do siatki
    const snapValue = getGridSnapValue(configContext.dragSnapSpacingCm);
    //console.log('snapValue', snapValue);

    // useEffect to handle text alignment changes
    useEffect(() => {
        if (!textSection[index] || !textSection[index].textAlign || textSection[index].textAlign === 'none') {
            return;
        }
        const currentAlignment = textSection[index].textAlign;
        const textSectionElement = document.querySelector(`#text-section-${index} .single-letter-container`);

        if (!textSectionElement) {
            return;
        }
        const textSectionWidth = textSectionElement.offsetWidth;
        const canvasWidth = workingSizeContext.widthPx;
        const newPosition = calculateAlignmentPosition(
            currentAlignment,
            textSectionWidth,
            canvasWidth,
            position.y,
            configContext.dragSnapSpacingCm,
            configContext.additionalWorkingSizeMargin / 2
        );
        setPosition(newPosition);
        textSectionDispatch({
            type: 'updateTextSectionPosition',
            payload: {
                index,
                position: newPosition
            }
        });
        //Musimy ustawić wyrównanie na 'none', aby była możliwość ponownego wyrównania
        textSectionDispatch({
            type: 'updateTextSectionTextAlign',
            payload: {
                index,
                textAlign: 'none',
            }
        });
    }, [textSection[index]?.textAlign, workingSizeContext.widthPx]);

    //WYSWIG
    const contentBlock = htmlToDraft(!rawValue ? value : rawValue);
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState));

    function updatePosition(e, data) {
        setPosition({
            x: position.x + data.deltaX,
            y: position.y + data.deltaY,
        });
        textSectionDispatch({
            type: 'updateTextSectionPosition',
            payload: {
                index,
                position: {
                    x: position.x + data.deltaX,
                    y: position.y + data.deltaY,
                }
            }
        });
    }

    function deactivateAllTextSections() {
        return new Promise((resolve) => {
            textSectionDispatch({
                type: 'deactivateAllTextSections'
            });
            resolve();
        })
    }

    function activateTextSection() {
        return new Promise((resolve) => {
            textSectionDispatch({
                type: 'updateTextSectionActive',
                payload: {
                    index,
                    active: true
                }
            });
            resolve();
        })
    }

    function deleteItem(e) {
        return new Promise((resolve) => {
            textSectionDispatch({
                type: 'removeTextSection',
                payload: {
                    index
                }
            });
            lettersDispatch({
                type: 'removeSection',
                payload: { sectionIndex: index }
            });
            resolve();
        });
    }

    async function activateItem(e) {
        await deactivateAllTextSections();
        await activateTextSection();
        configContextDispatch({
            type: 'changeFontSize',
            payload: textSection[index].fontSize
        });
        configContextDispatch({
            type: 'changeLetterSpacing',
            payload: textSection[index].letterSpacing
        })
    }

    async function closeEditingMode() {
        await deactivateAllTextSections();
        const content = editorState.getCurrentContent().getPlainText();
        if (content.trim() === '') {
            await deleteItem();
            return;
        }
    }

    async function removeTextSection() {
        await deactivateAllTextSections();
        await deleteItem();
    }

    const onEditorStateChange = async (newState) => {
        setEditorState(newState);
        configContextDispatch({
            'type': 'setErrorMsg',
            payload: false
        });

        const rawContent = await convertToRaw(newState.getCurrentContent());
        const content = rawContent.blocks.map(block => block.text).join(' ');

        // Only process further if text content actually changed
        const previousContent = textSection[index]?.rawContent || '';
        if (content === previousContent) {
            return;
        }

        // Pracuj na kopii slice'a tej sekcji
        let newLettersArray = [...sectionLetters];
        const contentSingleLetters = content.split('').map((letter, index) => {
            const nextLetter = content[index + 1] || '';
            if (letter.trim() === '') {
                const letterHtml = `<p class="single-letter" style="margin-right:15px"></p>`;
                newLettersArray[index] = {
                    id: `${index}_space`,
                    letter: ' ',
                    html: letterHtml,
                    margin: 0,
                };
                return letterHtml;
            }
            if (!newLettersArray[index]) {
                const letterHtml = `<p class="single-letter" style="margin-right:0">${letter}</p>`;
                newLettersArray[index] = {
                    id: `${index}_${letter}`,
                    letter: letter,
                    html: letterHtml,
                    margin: 0,
                };
                return letter.trim() === '' ? ' ' : letterHtml;
            }
            if (newLettersArray[index].letter === letter) {
                let letterHtml = newLettersArray[index].html;
                if (newLettersArray[index + 1] && newLettersArray[index + 1].letter === nextLetter) {
                    const margin = newLettersArray[index].margin;
                    letterHtml = `<p class="single-letter" style="margin-right:${margin}px">${letter}</p>`;
                }
                return letter.trim() === '' ? ' ' : letterHtml;
            }
            if (newLettersArray[index].letter !== letter) {
                let letterHtml = `<p class="single-letter" style="margin-right: 0">${letter}</p>`;
                if (newLettersArray[index + 1] && newLettersArray[index + 1].letter === nextLetter) {
                    newLettersArray[index] = {
                        id: `${index}_${letter}`,
                        letter: letter,
                        html: letterHtml,
                        margin: 0,
                    };
                    return letter.trim() === '' ? ' ' : letterHtml;
                }
            }
            const added = content.length > newLettersArray.length;
            if (added) {
                let letterHtml = `<p class="single-letter" style="margin-right:0">${letter}</p>`;
                newLettersArray.splice(index, 0, {
                    id: `${index}_${letter}`,
                    letter: letter,
                    html: letterHtml,
                    margin: 0,
                });
                return letter.trim() === '' ? ' ' : letterHtml;
            }
            if (!added) {
                //console.log(newLettersArray[index])
                newLettersArray.splice(index, 1);
                if(!newLettersArray[index]) {
                    return;
                }
                const margin = newLettersArray[index].margin;
                let letterHtml = `<p class="single-letter" style="margin-right: ${margin}px">${letter}</p>`;
                newLettersArray[index].html = letterHtml;
                return letter.trim() === '' ? ' ' : letterHtml;
            }
        });
        if (contentSingleLetters.length !== newLettersArray.length) {
            const diff = newLettersArray.length - contentSingleLetters.length;
            if (diff > 0) {
                newLettersArray.splice(contentSingleLetters.length, diff);
            }
        }
        lettersDispatch({
            type: 'setSectionLetters',
            payload: { sectionIndex: index, letters: newLettersArray }
        });
        const html = contentSingleLetters.join('');
        await updateTextSectionData(index, html, rawContent);
        recalculateAllPrices({ index, rawContent: content });
    }

    const updateTextSectionData = (index, html, rawContent) => {
        return new Promise((resolve) => {
            textSectionDispatch({
                type: "updateTextSectionData",
                payload: {
                    index,
                    value: html,
                    rawContent: rawContent.blocks.map(block => block.text).join(' ')
                }
            });
            resolve();
        });
    }

    const onChange = () => {
        const validateResult = validateAllLetters();
        if(validateResult) {
            priceDispatch({
                type: 'setAllowAddToCart',
                payload: true
            });
        }
    }

    const handleBeforeInput = (input) => {
        const validateResult = validateSingleLetterAndShowError(input);
        return validateResult ? 'not-handled' : 'handled';
    };

    /**
     * Funkcja walidująca wszystkie litery w treści
     */
    const validateAllLetters = () => {
        const content = editorState.getCurrentContent().getPlainText();
        let result = true;
        for (let i = 0; i < content.length; i++) {
            const char = content[i];
            // Wyklucz spację z walidacji
            if (char === ' ') continue;
            if (!checkIfSingIsAllowed(char, configContext)) {
                result = false;
                break;
            }
        }
        return result;
    };

    /**
     * Funkcja walidująca pojedynczy znak i wyświetlająca komunikat o błędzie
     * @param input
     * @returns {boolean}
     */
    const validateSingleLetterAndShowError = (input) => {
        //Wykluczamy spacę z walidacji
        const exceptions = [
            ' ' ,
            '.',
            ',',
            '-'
        ];
        if (exceptions.includes(input)) {
            return true;
        }
        //Sprawdzamy, czy znak jest dozwolony
        const result = checkIfSingIsAllowed(input, configContext);
        if (result) {
            return true;
        }

        //Jeżeli znak nie jest dozwolony to wyświetlamy komunikat
        const allowedChars = [
            configContext.allowedSmallLetters ? t('toolbar.smallLetters') : '',
            configContext.allowedBigLetters ? t('toolbar.bigLetters') : '',
            configContext.allowedNumbers ? t('toolbar.numbers') : '',
            configContext.allowedSpecial ? t('toolbar.specialChars') : ''
        ].filter(Boolean).join(', ');
        const errorMessage = `${t('textSection.invalidCharMessage')} <strong>${allowedChars}</strong>`;
        showErrorMessage(errorMessage, t('textSection.invalidCharTitle'));
        return false;
    }

    const showErrorMessage = (content, title = t('common.error'), timeout = 5000) => {
        return new Promise((resolve) => {
            //modalDispatch({type: "hideModal"});
           modalDispatch({
                type: "setModalContent",
                payload: {
                    title: title,
                    content: content,
                }
            });
            modalDispatch({type: "showModal"});
            //Czekamy 5 sekund i zamykamy modal
            setTimeout(() => {
                modalDispatch({type: "hideModal"});
            }, timeout);
            resolve();
        });
    }

    return (
        <Draggable
            bounds={'parent'}
            position={position}
            onDrag={updatePosition}
            grid={[snapValue, snapValue]}
            handle=".draghandle"
            aria-label={t('textSection.dragSection')}
        >
            <div onMouseDownCapture={activateItem} className={active ? 'active' : ''}>
                <div
                    id={`text-section-${index}`}
                    className={`text-section__content ${active ? 'active' : ''}`}
                    tabIndex="0"
                    aria-label={t('textSection.sectionLabel', {index: index + 1})}
                >
                    <TextSectionLetters
                        key={`letters-${index}-${textSection[index]?.fontSizeValue}`}
                        textSection={textSection}
                        index={index}
                        configContext={configContext}
                    />
                    {/*Edytor, zamykanie i przesuwanie sekcji tekstowej*/}
                    <div className="select-margin select-margin--last" style={{
                        position: 'relative',
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '5px',
                            width: '100%',
                            marginTop: '10px',
                        }}>

                            <Editor
                                editorState={editorState}
                                onEditorStateChange={onEditorStateChange}
                                toolbarHidden={true}
                                toolbar={{
                                    options: [],
                                }}
                                handleBeforeInput={handleBeforeInput}
                                onChange={onChange}
                                localization={{
                                    locale: 'en',
                                }}
                                ariaLabel={t('textSection.editorLabel', {index: index + 1})}
                                editorClassName="text-editor nopan nodrag"
                            />
                            <div className="text-section__close-editing-container text-section__close-editing-container--btns">
                                <span style={{
                                    fontSize: '10px',
                                    fontFamily: "Montserrat",
                                    textAlign: 'left',
                                    className: 'text-section__info',
                                }}>
                                    {t('textSection.editHint')} <br/>
                                </span>
                                <button
                                    onClick={removeTextSection}
                                    type="button"
                                    className="btn btn--smaller"
                                    aria-label={t('textSection.deleteSection')}
                                >
                                    {t('common.delete')}
                                </button>
                                <button
                                    onClick={closeEditingMode}
                                    type="button"
                                    className="btn btn--secondary btn--smaller"
                                    aria-label={t('textSection.saveAndClose')}
                                >
                                    {t('common.save')}
                                </button>
                            </div>
                            <div className="text-section__close-editing-container">
                                <span style={{
                                    fontSize: '10px',
                                    fontFamily: "Montserrat",
                                    textAlign: 'left',
                                }}>
                                    {t('textSection.allowedCharsInfo')} <br></br>
                                    <strong>{[
                                        configContext.allowedSmallLetters ? t('toolbar.smallLetters') : '',
                                        configContext.allowedBigLetters ? t('toolbar.bigLetters') : '',
                                        configContext.allowedNumbers ? t('toolbar.numbers') : '',
                                        configContext.allowedSpecial ? t('toolbar.specialChars') : ''
                                    ].filter(Boolean).join(', ')}</strong>
                                </span>

                            </div>
                        </div>
                    </div>
                    <div title={t('textSection.move')} className={`draghandle`} aria-label={t('textSection.moveSection')} tabIndex="0">
                        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="15"
                             height="15" aria-hidden="true" focusable="false">
                            <title>Drag</title>
                            <g id="Drag">
                                <path id="Path 266" className="s0" style={{"fill": "#f18914"}}
                                      d="m14.5 8q0.1-0.3 0-0.5-0.1-0.2-0.2-0.3l-2-2c-0.3-0.3-0.7-0.3-1 0-0.2 0.3-0.2 0.7 0 1l0.9 0.8h-3.8v-3.8l0.9 0.9c0.3 0.3 0.7 0.3 1 0 0.2-0.2 0.2-0.7 0-0.9l-2.1-2.1q-0.1-0.1-0.2-0.1-0.3-0.1-0.5 0-0.1 0-0.2 0.1l-2.1 2.1c-0.2 0.2-0.2 0.7 0 0.9 0.3 0.3 0.7 0.3 1 0l0.9-0.9v3.8h-3.8l0.9-0.8c0.2-0.3 0.2-0.7 0-1-0.3-0.3-0.7-0.3-1 0l-2 2q-0.1 0.1-0.2 0.3-0.1 0.2 0 0.5 0.1 0.1 0.2 0.2l2 2c0.3 0.3 0.7 0.3 1 0 0.2-0.2 0.2-0.7 0-0.9l-0.9-0.9h3.8v3.8l-0.9-0.9c-0.3-0.3-0.7-0.3-1 0-0.2 0.3-0.2 0.7 0 1l2.1 2q0.1 0.1 0.2 0.1 0.2 0.2 0.5 0 0.1 0 0.2-0.1l2.1-2c0.2-0.3 0.2-0.7 0-1-0.3-0.3-0.7-0.3-1 0l-0.9 0.9v-3.8h3.8l-0.9 0.9c-0.2 0.2-0.2 0.7 0 0.9 0.3 0.3 0.7 0.3 1 0l2-2q0.1-0.1 0.2-0.2z"/>
                            </g>
                        </svg>
                    </div>
                    {/*<div className="text-section__square"></div>*/}
                    {/*<div className="text-section__square text-section__square--n2"></div>*/}
                    {/*<div className="text-section__square text-section__square--n3"></div>*/}
                    {/*<div className="text-section__square text-section__square--n4"></div>*/}
                    {/*<div className="text-section__round text-section__round"></div>*/}
                    {/*<div className="text-section__round text-section__round--n2"></div>*/}
                    {/*<div className="text-section__round text-section__round--n3"></div>*/}
                    {/*<div className="text-section__round text-section__round--n4"></div>*/}
                </div>
            </div>
        </Draggable>
    )
}
export default TextSection;
